import { useAccountAdditionalData } from 'hooks';
import {
    COMMON_FLAGS,
    FEATURE_FLAGS,
    useCommonConfig,
    useConfigMatch,
} from 'modules/taboola-common-frontend-modules/account-configurations';

export const useIsFrequencyCappingPermitted = () => {
    const { accountAdditionalData: { advertiserGroupTier } = {} } = useAccountAdditionalData();
    const { [COMMON_FLAGS.FREQUENCY_CAPPING_ALLOWED_TIERS]: allowedTiers } = useCommonConfig([
        COMMON_FLAGS.FREQUENCY_CAPPING_ALLOWED_TIERS,
    ]);
    const tiersList = allowedTiers.trim().split(',');
    const isAccountInAllowedTier = tiersList.includes(advertiserGroupTier);
    const isAllowedFrequencyCapping = useConfigMatch({
        [FEATURE_FLAGS.FREQUENCY_CAPPING_ENABLED_CONFIG_ATTRIBUTE]: 'true',
    });
    return isAllowedFrequencyCapping || isAccountInAllowedTier;
};
